import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t border-gray-100 bg-white">
      <div className="mx-auto w-full max-w-7xl px-6 sm:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10">
          <div>
            <h3 className="font-heading text-lg font-bold text-gray-900 uppercase" style={{ letterSpacing: '0.05em' }}>
              Prophet Malluc
            </h3>
            <p className="mt-4 text-sm text-gray-500 leading-relaxed font-body">
              Prophet Malluc Ministries
            </p>
          </div>
          <div>
            <h4 className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-body font-medium mb-4">Ministries</h4>
            <div className="flex flex-col gap-3">
              <Link to="/revival-night" className="font-heading text-sm text-gray-600 hover:text-gray-900 transition-colors">Revival Night</Link>
              <Link to="/prophetic-school" className="font-heading text-sm text-gray-600 hover:text-gray-900 transition-colors">Prophetic School</Link>
              <Link to="/mentorship" className="font-heading text-sm text-gray-600 hover:text-gray-900 transition-colors">Mentorship</Link>
              <Link to="/about" className="font-heading text-sm text-gray-600 hover:text-gray-900 transition-colors">About</Link>
            </div>
          </div>
          <div>
            <h4 className="text-[11px] uppercase tracking-[0.15em] text-gray-400 font-body font-medium mb-4">Connect</h4>
            <p className="text-sm text-gray-600 font-body">info@prophetmalluc.com</p>
            <p className="text-sm text-gray-600 font-body mt-2">New Jersey &middot; New York City</p>
            <p className="text-sm text-gray-600 font-body mt-2">Abidjan, Ivory Coast</p>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-gray-100 text-center">
          <p className="text-xs text-gray-400 font-body">
            &copy; {new Date().getFullYear()} Prophet Malluc Ministries. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
